var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiveBreaksPatternLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "684px",
    height: "320px",
    viewBox: "0 0 684 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "live-breaks-pattern-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "live-breaks-pattern-light",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.049999997
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars",
    transform: "translate(5.000000, 5.410671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.765842,56.6821692 L285.76376,66.0291119 C287.745978,67.0043596 288.562288,69.401859 287.587041,71.3840767 C287.201084,72.1685433 286.568744,72.8049574 285.786772,73.1959433 L266.788854,82.6949023 C264.81294,83.6828593 262.410248,82.8819619 261.422291,80.9060479 C261.14458,80.3506262 261,79.7381739 261,79.1171935 L261,60.2712919 C261,58.0621529 262.790861,56.2712919 265,56.2712919 C265.612303,56.2712919 266.216434,56.4118614 266.765842,56.6821692 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7658421,14.6821692 L40.76376,24.0291119 C42.7459777,25.0043596 43.5622882,27.401859 42.5870405,29.3840767 C42.2010843,30.1685433 41.5687441,30.8049574 40.7867722,31.1959433 L21.7888544,40.6949023 C19.8129404,41.6828593 17.4102482,40.8819619 16.4222912,38.9060479 C16.1445804,38.3506262 16,37.7381739 16,37.1171935 L16,18.2712919 C16,16.0621529 17.790861,14.2712919 20,14.2712919 C20.6123034,14.2712919 21.2164341,14.4118614 21.7658421,14.6821692 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.758189,0.407122146 L369.717047,30.7269352 C371.701338,31.6979562 372.522757,34.0937105 371.551736,36.0780021 C371.164874,36.8685581 370.528072,37.5094495 369.740008,37.9013634 L307.78115,68.7142899 C305.803115,69.6979922 303.402152,68.8919257 302.41845,66.91389 C302.14323,66.3604759 302,65.7508117 302,65.1327396 L302,4 C302,1.790861 303.790861,1.46549439e-14 306,1.42108547e-14 C306.609425,1.42108547e-14 307.210792,0.139251237 307.758189,0.407122146 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.758189,61.4071221 L134.717047,91.7269352 C136.701338,92.6979562 137.522757,95.0937105 136.551736,97.0780021 C136.164874,97.8685581 135.528072,98.5094495 134.740008,98.9013634 L72.7811505,129.71429 C70.8031148,130.697992 68.4021519,129.891926 67.4184496,127.91389 C67.1432298,127.360476 67,126.750812 67,126.13274 L67,65 C67,62.790861 68.790861,61 71,61 C71.6094246,61 72.210792,61.1392512 72.758189,61.4071221 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.765842,230.682169 L318.76376,240.029112 C320.745978,241.00436 321.562288,243.401859 320.587041,245.384077 C320.201084,246.168543 319.568744,246.804957 318.786772,247.195943 L299.788854,256.694902 C297.81294,257.682859 295.410248,256.881962 294.422291,254.906048 C294.14458,254.350626 294,253.738174 294,253.117194 L294,234.271292 C294,232.062153 295.790861,230.271292 298,230.271292 C298.612303,230.271292 299.216434,230.411861 299.765842,230.682169 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.765842,63.6821692 L395.76376,73.0291119 C397.745978,74.0043596 398.562288,76.401859 397.587041,78.3840767 C397.201084,79.1685433 396.568744,79.8049574 395.786772,80.1959433 L376.788854,89.6949023 C374.81294,90.6828593 372.410248,89.8819619 371.422291,87.9060479 C371.14458,87.3506262 371,86.7381739 371,86.1171935 L371,67.2712919 C371,65.0621529 372.790861,63.2712919 375,63.2712919 C375.612303,63.2712919 376.216434,63.4118614 376.765842,63.6821692 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.765842,116.682169 L653.76376,126.029112 C655.745978,127.00436 656.562288,129.401859 655.587041,131.384077 C655.201084,132.168543 654.568744,132.804957 653.786772,133.195943 L634.788854,142.694902 C632.81294,143.682859 630.410248,142.881962 629.422291,140.906048 C629.14458,140.350626 629,139.738174 629,139.117194 L629,120.271292 C629,118.062153 630.790861,116.271292 633,116.271292 C633.612303,116.271292 634.216434,116.411861 634.765842,116.682169 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.777283,9.45467036 L649.832964,14.937922 C651.812061,15.9194883 652.620719,18.3195797 651.639153,20.2986761 C651.254595,21.0740453 650.628923,21.7037681 649.856051,22.093321 L638.80037,27.6657508 C636.827649,28.6600677 634.422389,27.8669142 633.428072,25.894193 C633.146614,25.3357809 633,24.7191571 633,24.093823 L633,13.0381415 C633,10.8290025 634.790861,9.0381415 637,9.0381415 C637.616613,9.0381415 638.224879,9.18069623 638.777283,9.45467036 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.777283,196.45467 L197.832964,201.937922 C199.812061,202.919488 200.620719,205.31958 199.639153,207.298676 C199.254595,208.074045 198.628923,208.703768 197.856051,209.093321 L186.80037,214.665751 C184.827649,215.660068 182.422389,214.866914 181.428072,212.894193 C181.146614,212.335781 181,211.719157 181,211.093823 L181,200.038141 C181,197.829002 182.790861,196.038141 185,196.038141 C185.616613,196.038141 186.224879,196.180696 186.777283,196.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.777283,31.4546704 L130.832964,36.937922 C132.812061,37.9194883 133.620719,40.3195797 132.639153,42.2986761 C132.254595,43.0740453 131.628923,43.7037681 130.856051,44.093321 L119.80037,49.6657508 C117.827649,50.6600677 115.422389,49.8669142 114.428072,47.894193 C114.146614,47.3357809 114,46.7191571 114,46.093823 L114,35.0381415 C114,32.8290025 115.790861,31.0381415 118,31.0381415 C118.616613,31.0381415 119.224879,31.1806962 119.777283,31.4546704 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.777283,180.45467 L118.832964,185.937922 C120.812061,186.919488 121.620719,189.31958 120.639153,191.298676 C120.254595,192.074045 119.628923,192.703768 118.856051,193.093321 L107.80037,198.665751 C105.827649,199.660068 103.422389,198.866914 102.428072,196.894193 C102.146614,196.335781 102,195.719157 102,195.093823 L102,184.038141 C102,181.829002 103.790861,180.038141 106,180.038141 C106.616613,180.038141 107.224879,180.180696 107.777283,180.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.777283,270.45467 L183.832964,275.937922 C185.812061,276.919488 186.620719,279.31958 185.639153,281.298676 C185.254595,282.074045 184.628923,282.703768 183.856051,283.093321 L172.80037,288.665751 C170.827649,289.660068 168.422389,288.866914 167.428072,286.894193 C167.146614,286.335781 167,285.719157 167,285.093823 L167,274.038141 C167,271.829002 168.790861,270.038141 171,270.038141 C171.616613,270.038141 172.224879,270.180696 172.777283,270.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7772829,142.45467 L32.8329645,147.937922 C34.8120609,148.919488 35.6207189,151.31958 34.6391527,153.298676 C34.2545952,154.074045 33.628923,154.703768 32.8560515,155.093321 L21.80037,160.665751 C19.8276487,161.660068 17.4223891,160.866914 16.4280722,158.894193 C16.1466141,158.335781 16,157.719157 16,157.093823 L16,146.038141 C16,143.829002 17.790861,142.038141 20,142.038141 C20.6166134,142.038141 21.2248788,142.180696 21.7772829,142.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.777283,12.4546704 L236.832964,17.937922 C238.812061,18.9194883 239.620719,21.3195797 238.639153,23.2986761 C238.254595,24.0740453 237.628923,24.7037681 236.856051,25.093321 L225.80037,30.6657508 C223.827649,31.6600677 221.422389,30.8669142 220.428072,28.894193 C220.146614,28.3357809 220,27.7191571 220,27.093823 L220,16.0381415 C220,13.8290025 221.790861,12.0381415 224,12.0381415 C224.616613,12.0381415 225.224879,12.1806962 225.777283,12.4546704 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.777283,228.45467 L547.832964,233.937922 C549.812061,234.919488 550.620719,237.31958 549.639153,239.298676 C549.254595,240.074045 548.628923,240.703768 547.856051,241.093321 L536.80037,246.665751 C534.827649,247.660068 532.422389,246.866914 531.428072,244.894193 C531.146614,244.335781 531,243.719157 531,243.093823 L531,232.038141 C531,229.829002 532.790861,228.038141 535,228.038141 C535.616613,228.038141 536.224879,228.180696 536.777283,228.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.777283,267.45467 L424.832964,272.937922 C426.812061,273.919488 427.620719,276.31958 426.639153,278.298676 C426.254595,279.074045 425.628923,279.703768 424.856051,280.093321 L413.80037,285.665751 C411.827649,286.660068 409.422389,285.866914 408.428072,283.894193 C408.146614,283.335781 408,282.719157 408,282.093823 L408,271.038141 C408,268.829002 409.790861,267.038141 412,267.038141 C412.616613,267.038141 413.224879,267.180696 413.777283,267.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.777283,177.45467 L635.832964,182.937922 C637.812061,183.919488 638.620719,186.31958 637.639153,188.298676 C637.254595,189.074045 636.628923,189.703768 635.856051,190.093321 L624.80037,195.665751 C622.827649,196.660068 620.422389,195.866914 619.428072,193.894193 C619.146614,193.335781 619,192.719157 619,192.093823 L619,181.038141 C619,178.829002 620.790861,177.038141 623,177.038141 C623.616613,177.038141 624.224879,177.180696 624.777283,177.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.777283,86.4546704 L547.832964,91.937922 C549.812061,92.9194883 550.620719,95.3195797 549.639153,97.2986761 C549.254595,98.0740453 548.628923,98.7037681 547.856051,99.093321 L536.80037,104.665751 C534.827649,105.660068 532.422389,104.866914 531.428072,102.894193 C531.146614,102.335781 531,101.719157 531,101.093823 L531,90.0381415 C531,87.8290025 532.790861,86.0381415 535,86.0381415 C535.616613,86.0381415 536.224879,86.1806962 536.777283,86.4546704 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.777283,173.45467 L295.832964,196.792729 C297.812061,197.774295 298.620719,200.174387 297.639153,202.153483 C297.254595,202.928852 296.628923,203.558575 295.856051,203.948128 L248.80037,227.665751 C246.827649,228.660068 244.422389,227.866914 243.428072,225.894193 C243.146614,225.335781 243,224.719157 243,224.093823 L243,177.038141 C243,174.829002 244.790861,173.038141 247,173.038141 C247.616613,173.038141 248.224879,173.180696 248.777283,173.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.766849,50.4286182 L295.769879,111.481097 C297.751823,112.4569 298.567461,114.854628 297.591657,116.836573 C297.205822,117.620238 296.574068,118.256064 295.792897,118.646926 L171.789868,180.692346 C169.814233,181.680862 167.411315,180.880645 166.422798,178.905011 C166.144759,178.349326 166,177.736507 166,177.115144 L166,54.0172455 C166,51.8081065 167.790861,50.0172455 170,50.0172455 C170.612682,50.0172455 171.217177,50.157989 171.766849,50.4286182 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7615571,201.415469 L135.737647,239.664042 C137.721027,240.636923 138.540198,243.033446 137.567317,245.016827 C137.180851,245.804702 136.546013,246.443623 135.76063,246.835132 L57.784541,285.705769 C55.8074376,286.691343 53.4057125,285.887551 52.4201378,283.910447 C52.1438232,283.356149 52,282.745258 52,282.125906 L52,205.006697 C52,202.797558 53.790861,201.006697 56,201.006697 C56.6106911,201.006697 57.2132744,201.146527 57.7615571,201.415469 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.755238,34.3998229 L487.698944,59.7658358 C489.684032,60.7352271 490.507418,63.1303061 489.538026,65.1153944 C489.150822,65.9082991 488.512299,66.5509171 487.721886,66.9431824 L435.77818,92.7217414 C433.799329,93.703803 431.399035,92.8957458 430.416974,90.9168951 C430.142711,90.3642567 430,89.7556669 430,89.1387153 L430,37.9941433 C430,35.7850043 431.790861,33.9941433 434,33.9941433 C434.608315,33.9941433 435.208618,34.1328883 435.755238,34.3998229 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.777283,247.45467 L257.832964,266.824994 C259.812061,267.80656 260.620719,270.206652 259.639153,272.185748 C259.254595,272.961117 258.628923,273.59084 257.856051,273.980393 L218.80037,293.665751 C216.827649,294.660068 214.422389,293.866914 213.428072,291.894193 C213.146614,291.335781 213,290.719157 213,290.093823 L213,251.038141 C213,248.829002 214.790861,247.038141 217,247.038141 C217.616613,247.038141 218.224879,247.180696 218.777283,247.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.765842,5.68216919 L533.76376,15.0291119 C535.745978,16.0043596 536.562288,18.401859 535.587041,20.3840767 C535.201084,21.1685433 534.568744,21.8049574 533.786772,22.1959433 L514.788854,31.6949023 C512.81294,32.6828593 510.410248,31.8819619 509.422291,29.9060479 C509.14458,29.3506262 509,28.7381739 509,28.1171935 L509,9.27129186 C509,7.06215286 510.790861,5.27129186 513,5.27129186 C513.612303,5.27129186 514.216434,5.41186138 514.765842,5.68216919 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.777283,40.4546704 L651.832964,68.2564309 C653.812061,69.2379971 654.620719,71.6380885 653.639153,73.6171849 C653.254595,74.3925541 652.628923,75.0222769 651.856051,75.4118298 L595.80037,103.665751 C593.827649,104.660068 591.422389,103.866914 590.428072,101.894193 C590.146614,101.335781 590,100.719157 590,100.093823 L590,44.0381415 C590,41.8290025 591.790861,40.0381415 594,40.0381415 C594.616613,40.0381415 595.224879,40.1806962 595.777283,40.4546704 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.777283,108.45467 L387.832964,125.841127 C389.812061,126.822693 390.620719,129.222784 389.639153,131.201881 C389.254595,131.97725 388.628923,132.606973 387.856051,132.996526 L352.80037,150.665751 C350.827649,151.660068 348.422389,150.866914 347.428072,148.894193 C347.146614,148.335781 347,147.719157 347,147.093823 L347,112.038141 C347,109.829002 348.790861,108.038141 351,108.038141 C351.616613,108.038141 352.224879,108.180696 352.777283,108.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76584214,166.682169 L24.76376,176.029112 C26.7459777,177.00436 27.5622882,179.401859 26.5870405,181.384077 C26.2010843,182.168543 25.5687441,182.804957 24.7867722,183.195943 L5.78885438,192.694902 C3.81294039,193.682859 1.41024823,192.881962 0.422291236,190.906048 C0.144580367,190.350626 4.1268521e-16,189.738174 0,189.117194 L0,170.271292 C-2.04689834e-15,168.062153 1.790861,166.271292 4,166.271292 C4.61230345,166.271292 5.2164341,166.411861 5.76584214,166.682169 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.757664,180.405822 L434.713828,209.734747 C436.698262,210.705478 437.52003,213.101112 436.549299,215.085545 C436.162376,215.876519 435.525268,216.517718 434.736786,216.909695 L374.780622,246.715617 C372.802441,247.699027 370.401597,246.892607 369.418187,244.914426 C369.143137,244.36115 369,243.751677 369,243.133804 L369,183.998957 C369,181.789818 370.790861,179.998957 373,179.998957 C373.609227,179.998957 374.210405,180.138118 374.757664,180.405822 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.765842,266.682169 L533.76376,276.029112 C535.745978,277.00436 536.562288,279.401859 535.587041,281.384077 C535.201084,282.168543 534.568744,282.804957 533.786772,283.195943 L514.788854,292.694902 C512.81294,293.682859 510.410248,292.881962 509.422291,290.906048 C509.14458,290.350626 509,289.738174 509,289.117194 L509,270.271292 C509,268.062153 510.790861,266.271292 513,266.271292 C513.612303,266.271292 514.216434,266.411861 514.765842,266.682169 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.754892,231.398968 L640.696818,256.269701 C642.682,257.238902 643.505615,259.633901 642.536415,261.619083 C642.149171,262.412263 641.510446,263.055083 640.719757,263.44739 L589.777831,288.722614 C587.798885,289.704484 585.39867,288.896193 584.416801,286.917247 C584.14265,286.364699 584,285.756236 584,285.139415 L584,234.993457 C584,232.784318 585.790861,230.993457 588,230.993457 C588.608185,230.993457 589.208363,231.132143 589.754892,231.398968 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.763915,118.421323 L576.75203,164.60066 C578.734771,165.574843 579.552368,167.971904 578.578185,169.954645 C578.191998,170.740644 577.558535,171.378186 576.775029,171.769408 L482.786915,218.699793 C480.810465,219.686678 478.408208,218.884478 477.421322,216.908029 C477.14424,216.353112 477,215.741362 477,215.121115 L477,122.011394 C477,119.802255 478.790861,118.011394 481,118.011394 C481.611578,118.011394 482.215013,118.15163 482.763915,118.421323 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7772829,270.45467 L30.8329645,275.937922 C32.8120609,276.919488 33.6207189,279.31958 32.6391527,281.298676 C32.2545952,282.074045 31.628923,282.703768 30.8560515,283.093321 L19.80037,288.665751 C17.8276487,289.660068 15.4223891,288.866914 14.4280722,286.894193 C14.1466141,286.335781 14,285.719157 14,285.093823 L14,274.038141 C14,271.829002 15.790861,270.038141 18,270.038141 C18.6166134,270.038141 19.2248788,270.180696 19.7772829,270.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.777283,269.45467 L365.832964,282.873392 C367.812061,283.854958 368.620719,286.255049 367.639153,288.234146 C367.254595,289.009515 366.628923,289.639238 365.856051,290.028791 L338.80037,303.665751 C336.827649,304.660068 334.422389,303.866914 333.428072,301.894193 C333.146614,301.335781 333,300.719157 333,300.093823 L333,273.038141 C333,270.829002 334.790861,269.038141 337,269.038141 C337.616613,269.038141 338.224879,269.180696 338.777283,269.45467 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveBreaksPatternLight);
export default __webpack_public_path__ + "static/media/live-breaks-pattern-light.492e144ddff1c9da22d1f2ab76e14b70.svg";
export { ForwardRef as ReactComponent };